// ══════════════════════════════════════════════════════
//  _shared.js — extractor 工具
//
//  合约：所有数字函数遇到 null/undefined/NaN/Infinity 必须返回 null，
//  不允许抛错。这是 PR #1 verdict 崩溃的根本原因防护层。
// ══════════════════════════════════════════════════════

/** 转数字；非有限值（null/undefined/NaN/Infinity）返回 null */
export function safeNum(v) {
  if (v == null) return null;
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : null;
}

/** 安全除法；分子或分母 null/0 返回 null */
export function safeDiv(a, b) {
  const na = safeNum(a);
  const nb = safeNum(b);
  if (na == null || nb == null || nb === 0) return null;
  return na / nb;
}

/** 安全乘法；任一参数 null 返回 null */
export function safeMul(a, b) {
  const na = safeNum(a);
  const nb = safeNum(b);
  if (na == null || nb == null) return null;
  return na * nb;
}

/** 美元金额格式化（$XB / $XM / $XK / $X） */
export function fmtUSD(v) {
  const n = safeNum(v);
  if (n == null) return '—';
  if (n >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
  if (n >= 1e9)  return `$${(n / 1e9).toFixed(2)}B`;
  if (n >= 1e6)  return `$${(n / 1e6).toFixed(2)}M`;
  if (n >= 1e3)  return `$${(n / 1e3).toFixed(1)}K`;
  return `$${n.toFixed(2)}`;
}

/** 倍数格式化（带 x 后缀） */
export function fmtRatio(v, digits = 1) {
  const n = safeNum(v);
  if (n == null) return '—';
  return `${n.toFixed(digits)}x`;
}

/** 百分比格式化（输入 0.123 → "12.3%"） */
export function fmtPct(v, digits = 1) {
  const n = safeNum(v);
  if (n == null) return '—';
  return `${(n * 100).toFixed(digits)}%`;
}

/** 月→年 化（30日数字 * 365/30） */
export const ANNUALIZE_30D = 365 / 30;

/** 安全访问嵌套属性，全程 ?. */
export function pick(obj, path) {
  if (!obj) return undefined;
  return path.split('.').reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
}
